var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"mx-auto ml-5 my-5 mx-5 mr-5 ",attrs:{"outlined":""}},[_c('highcharts',{ref:"highcharts",attrs:{"options":_vm.chartOptions}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }